// [목적] GET /rag/concepts 목록 조회 훅 — useQuery + zod 파싱(hooks/useFestivals.ts 패턴 재사용)
// [이유] FlowLine 83963a6b 과업1: ChatPage/ChatMobile 추천 칩을 실데이터로 렌더하기 위한 조회 훅.
//        5종 컨셉은 BE 서버 결정적 상수(LLM 미개입)라 자주 바뀌지 않으므로 staleTime 을 길게 잡아
//        재요청을 최소화한다(useFestivals 의 5분보다 더 긴 1시간 — festivals 는 야간 배치로 바뀌지만
//        concepts 는 배포 시에만 바뀜).
// [사이드 이팩트] listConcepts → fetchWithEnvelope 경유(공개 GET, 인증 불요).
// [수정 시 고려사항] throwOnError:false — 실패 시 호출부(ChatPage/ChatMobile)가 칩 영역만 숨기고
//                   채팅 자체는 정상 동작해야 한다(요구사항: "실패 시 칩 영역 숨김").

import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../api/queryKeys.js';
import { listConcepts, type Concept } from '../api/concepts.client.js';

/**
 * [목적] GET /rag/concepts 래핑 훅
 * [이유] ChatPage/ChatMobile 첫 진입 추천 칩 렌더링에 필요한 5종 목록을 단일 쿼리로 제공.
 * [사이드 이팩트] 없음.
 * [수정 시 고려사항] 에러/빈 배열 시 호출부가 칩 영역을 숨기도록 처리해야 함(throwOnError:false).
 */
export function useConcepts() {
  return useQuery<Concept[]>({
    queryKey: queryKeys.rag.concepts(),
    queryFn: listConcepts,
    staleTime: 1000 * 60 * 60, // 1시간 — 서버 결정적 상수, 배포 전까지 사실상 불변
    throwOnError: false,
  });
}
